import { validate, validateEmail, validatePhone } from "./utils";


export const validateNeedHelp = () => {
  return validate(".needhelp-form .name input") && validate(".needhelp-form .email input", validateEmail);
}

export const checkSearchForm = () => {
  let result = false;
  // if (validate(".export-country select", undefined, false, false)) {
  //   window.$(".search-row .destination-country").removeClass("disable");
  window.$(".search-row .product").removeClass("disable");
  window.$(".go-button").removeClass("disable");

  if (validate(".destination-country select", undefined, false, false)) {
    // window.$(".search-row .product").removeClass("disable");
    // // if (validate(".product input.form-control", undefined, false, false, window.searchData.hs || "")) {
    // if (validate(".product input.form-control", undefined, false, false)) {
    //   // window.$(".search-row .order-info").removeClass("disable");
    //   // if (validate(".order-info .order-info-label", undefined, false, false, window.$(".order-info .order-info-label span").text())) {
    //   //   window.$(".go-button").removeClass("disable");
    //   //   result = true;
    //   // } else {
    //   //   window.$(".go-button").addClass("disable");
    //   // }
    //   result = true;
    //   window.$(".go-button").removeClass("disable");
    // } else {
    //   if (!window.$(".product input.form-control").is(":focus")) {
    //     window.$(".product input.form-control").focus();
    //   }
    //   // window.$(".search-row .order-info").addClass("disable");
    //   window.$(".search-row  .go-button").addClass("disable");
    // }
    result = true;
  } else {
    // window.$(".search-row .product").addClass("disable");
    // window.$(".search-row .order-info").addClass("disable");
    // window.$(".search-row  .go-button").addClass("disable");
  }
  // } else {
  //   window.$(".search-row .destination-country").addClass("disable");
  //   window.$(".search-row .product").addClass("disable");
  //   window.$(".search-row .order-info").addClass("disable");
  //   window.$(".search-row  .go-button").addClass("disable");
  // }
  return result;
}

export const checkSearchFormClassification = () => {
  if (validate(".destination-country select", undefined, false, false)) {
    window.$(".search-row .product").removeClass("disable");
    window.$(".search-row .description").removeClass("disable");
    if (validate(".product input.form-control", undefined, false, false, window.$(".product input.form-control").attr("data") || "") ||
      validate(".description textarea.form-control", undefined, false, false)
    ) {
      window.$(".search-row .go-button").removeClass("disable");
    } else {
      window.$(".search-row  .go-button").addClass("disable");
    }
  } else {
    window.$(".search-row  .go-button").addClass("disable");
  }
}

export const validateUKMeetingForm = (parent = "#meeting-form", requireUserInfo = false) => {
  let result1 = validate(`${parent} .company-name input`);
  let result2 = validate(`${parent} .phone input`, validatePhone);
  let result3 = validate(`${parent} .role input`);
  if (requireUserInfo) {
    let result4 = validate(`${parent} .name input`);
    let result5 = validate(`${parent} .email input`, validateEmail);
    return result1 && result2 && result3 && result4 && result5;
  }
  return result1 && result2 && result3;
}

export const validateBlogSubscribe = (parent = "#subscribe-form") => {
  let result1 = validate(`${parent} .name input`);
  let result2 = validate(`${parent} .email input`, validateEmail);
  return result1 && result2;
}

export const validateOrderInfo = () => {
  let inputs = window.$("#order-info .data-form .input-list input, #order-info .data-form .input-list select");
  let result = true;
  inputs.each((index, element) => {
    result &= validate(window.$(element));
  });

  return result;
}

export const validateBookNow = (parent = "#booknow-modal") => {
  let result1 = validate(`${parent} .company-name input`);
  let result2 = validate(`${parent} .contact-name input`);
  let result3 = validate(`${parent} .email input`, validateEmail);
  return result1 && result2 & result3;
}
